import React from 'react';
import { Section } from './ui/Section';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
export function ForWhoSection() {
  return <Section alternate data-id="element-56">
      <h2 className="text-3xl md:text-4xl font-serif text-cream-50 mb-10 text-center" data-id="element-57">
        Para quién es{' '}
        <span className="text-lg font-sans font-normal opacity-60 block mt-2" data-id="element-58">
          (y para quién no)
        </span>
      </h2>

      <div className="grid grid-cols-1 gap-8" data-id="element-59">
        <div className="bg-warm-900/50 p-6 rounded-xl border border-green-900/30" data-id="element-60">
          <h3 className="text-xl font-bold text-green-400 mb-4 flex items-center" data-id="element-61">
            <CheckCircle2Icon className="w-6 h-6 mr-2" data-id="element-62" />
            Esto es para ti si:
          </h3>
          <ul className="space-y-3" data-id="element-63">
            {['te despiertas 3+ noches por semana', 'sientes calor/sudor y luego tu mente se acelera', 'quieres algo simple, repetible y respetuoso', 'te importa la seguridad nocturna'].map((item, i) => <li key={i} className="flex items-start text-cream-100" data-id="element-64">
                <span className="mr-2 text-green-400/50" data-id="element-65">•</span>
                {item}
              </li>)}
          </ul>
        </div>

        <div className="bg-warm-900/50 p-6 rounded-xl border border-red-900/30" data-id="element-66">
          <h3 className="text-xl font-bold text-red-400 mb-4 flex items-center" data-id="element-67">
            <XCircleIcon className="w-6 h-6 mr-2" data-id="element-68" />
            No es para ti si:
          </h3>
          <ul className="space-y-3" data-id="element-69">
            {['buscas promesas médicas o curas hormonales', 'quieres un método complejo con aparatos o rutinas largas', 'no estás dispuesta a probar 7 días antes de juzgar'].map((item, i) => <li key={i} className="flex items-start text-cream-100" data-id="element-70">
                <span className="mr-2 text-red-400/50" data-id="element-71">•</span>
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}